/* global Phaser */

//@TODO Disattivare gli input del tavolo del giocatore durante un power altrimenti succede un casino
//@TODO Disattivare tutti gli altri aiuti qdurante un power altrimenti succede un casino
//@TODO Durante un power 1. tween che toglie i punti power 2. tween in caso di disattivazione di un potere per punti insufficienti

import Letter from '@/objects/letter';
import * as setup from '@/setup';
import * as Constants from '@/constants';
import { drawGameScene, drawGameBoard, drawPlayerBoard, drawSuperPower } from '@/gui/game-scene.js';
import { createDitloide, createLetterOfSolution, initialWordHelp, hasUnsolvedLetter, findWords, findLetter, findBoxLetter, countSchemaLetters } from '@/utils/ditloide';
import Cursor from '@/utils/cursor';
import runtime from '@/runtime';
import { getModel} from '@/utils/model';
import EventDispatcher from '@/utils/events';
import * as audio from '@/utils/audio';
import Button from '@/objects/button';
import axios from 'axios';
export default class Game extends Phaser.Scene {
	/**
	 *  A sample Game scene, displaying the Phaser logo.
	 *
	 *  @extends Phaser.Scene
	 */
	constructor() {
		super({key: 'Game'});
	}

	/* inizializzazione delle variabili di istanza */
	init() {
		// Puntatore al cursore
		this._cursor = null;
		// Stringa con il titolo del ditloide
		this._ditloide = null;
		// Array di oggetti sprite delle caselle del tavolo da gioco { id: id, char:'' }
		this._boardBoxes = [];
		// Array di oggetti testo del tavolo da gioco
		this._boardLetters = [];
		// Array di oggetti sprite delle caselle del giocatore { id: this.getLength() - 1, char: ''}
		this._playerBoxes = [];
		// Array delle lettere dello schema e della soluzione
		this._schemaArray = [];
		this._solutionArray = [];
		// Contatore lettere mancanti per finire lo schema
		this._toWinLetters = null;
		// Contatori tempo, score e power
		this._clockCounter = null;
		this._scoreCounter = null;
		this._powerCounter = null;
		// Coda fifo che contiene le lettere da giocare (player o superpotere)
		this._toPlayLetters = [];
		// Help Button
		this._helpButton = null;
		// Bottoni superpower
		this._superPowerButtons = null;
		// Oggetto timer
		this._timerObj = null;
		// Flag per indicare se il gioco è finito (per fermare l'aggiornamento di time_used)
		this._gameOver = false;
		// Flag per tracciare se sono stati usati superpower (solo in memoria, non nel database)
		this._powersUsed = false;

		// Reset crediti spesi per questo round
		runtime._creditsSpentThisRound = 0;
		// Reset dettaglio aiuti usati per questo round
		runtime._helpsUsedThisRound = {};

		// UI ready
		this._uiReady = true;

		// Riferimenti al popup di conferma
		this._confirmPopup = null;
		this._confirmOverlay = null;

		// se c'è un round precedente carico le lettere precedenti
		this._boardLetters = runtime.round.current_solved_letters ? runtime.round.current_solved_letters : [];
		// Inizializzo il ditloide
		// Le parentesi NON vengono rimosse qui - vengono gestite da createDitloide come "articoli"
		let stringSolution =
			runtime.dict.title.toUpperCase().trim() +
			' di ' +
			runtime.dict.author.toUpperCase().trim();
		this._ditloide = createDitloide(stringSolution);
		//console.log('ditloide', this._ditloide);
		// Inizializzo l'array delle lettere dello schema. Spazio = casella da indovinare, False = separatore delle parole
		this._schemaArray = initialWordHelp(stringSolution, this._ditloide);
		//console.log('schemaArray', this._schemaArray);
		// Inizializzo l'array di caratteri della soluzione
		this._solutionArray = [...stringSolution];
		//console.log('solutionArray', this._solutionArray);

	}

	preload() {
		//console.log('preload game scene');
	}
	/**
	 *  Called when a scene is initialized. Method responsible for setting up
	 *  the game objects of the scene.
	 *
	 *  @protected
	 *  @param {object} data Initialization parameters.
	 */
	create() {

		// Fisso un alias per evitare conflitti con il this all'interno del contesto degli eventi
		let gameScene = this;
		this.emitter = EventDispatcher.getInstance();
		console.log('emitter', this.emitter);
		// calcolo il margine sinistro di allineamento per centrare il gioco. C'è da considerare un fattore correttivo di allineamento del gruppo,
		// perchè la prima casella del gruppo ha origin 0.5 invece che 0. Quindi l'allineamento è sbilanciato di mezzo box
		let leftMargin = setup.box.width / 2 + (this.sys.game.config.width - setup.box.rows * setup.box.width) / 2;
		// calcolo la cooordinata y al termine del tavolo da gioco utile a piazzare la parte bassa con superpoteri e punteggi
		let gridPlayerBoxesCoord = {
			y:
				setup.styles.backgroundLogo.height +
				setup.styles.backgroundDitloide.height +
				setup.box.height / 2 +
				setup.box.cols * setup.box.height +
				setup.margin.lettersMarginTop
		};
		// disegno la gui della scena e ritorno gli oggetti phaser interattivi
		let {helpButton, menuButton, clockCounter, powerCounter, scoreCounter} = drawGameScene(this, leftMargin, this._ditloide);
		this._helpButton = helpButton;
		this._menuButton = menuButton;
		this._clockCounter = clockCounter;
		this._powerCounter = powerCounter;
		this._scoreCounter = scoreCounter;
		// disegno il tavolo da gioco 10x2 e ritorno gli oggetti phaser interattivi e inizializzati
		let {boardBoxes, boardLetters} = drawGameBoard(this, leftMargin, this._solutionArray, this._schemaArray);
		this._boardBoxes = boardBoxes;
		this._boardLetters = boardLetters;
		// Inizializzo le lettere mancanti per finire lo schema
		this._toWinLetters = runtime.round.missed_letters
			? runtime.round.missed_letters
			: this._solutionArray.length - countSchemaLetters(this._schemaArray);
		// Posiziono il cursore
		this._cursor = new Cursor(this._boardBoxes);
		this._cursor.move(this._cursor.index);

		// Log per debug: stampa la struttura dello schema
		console.log('[Game] Schema inizializzato. Dettaglio caselle:');
		this._boardBoxes.getChildren().forEach((box, index) => {
			console.log('[Game] Casella', index, ': char=', JSON.stringify(box.datas.char), 'solution=', box.datas.solution, 'interattiva=', box.input && box.input.enabled);
		});

		// Aggiungo eventi click alle caselle dello schema per permettere lo spostamento del cursore
		Phaser.Actions.Call(this._boardBoxes.getChildren(), function (box) {
			// Solo le caselle vuote e interattive possono essere cliccate per spostare il cursore
			if (box.input && box.input.enabled && box.datas.char === ' ') {
				box.on('pointerup', function () {
					// Sposta il cursore su questa casella solo se la UI è pronta
					if (box.scene._uiReady) {
						box.scene._cursor.move(box.datas.id);
					}
				});
				box.on('pointerover', function () {
					// Evidenzia la casella quando ci passi sopra (solo se UI è pronta)
					if (box.scene._uiReady && box.datas.id !== box.scene._cursor.index) {
						this.setTint(setup.colors.letterOver);
					}
				});
				box.on('pointerout', function () {
					// Rimuovi l'evidenziazione quando esci dalla casella (se non è il cursore attivo)
					if (box.datas.id !== box.scene._cursor.index) {
						this.setTint();
					}
				});
			}
		});
		// disegno tavolo del giocatore 10x2
		let uniqLetters = createLetterOfSolution(runtime.dict.title + runtime.dict.author);
		let {playerBoxes, playerLetters} = drawPlayerBoard(this, leftMargin, gridPlayerBoxesCoord, uniqLetters);
		this._playerBoxes = playerBoxes;
		this._playerLetters = playerLetters;
		//console.log('playerBoxes', this._playerBoxes);
		// disegno il menu dei superpoteri
		let {superPowerButtons} = drawSuperPower(this, gridPlayerBoxesCoord);
		this._superPowerButtons = superPowerButtons;
		// Controlla immediatamente se i bottoni devono essere disabilitati in base ai crediti disponibili
		this.updateSuperPowerButtons();

		// assegno gli eventi alle caselle del tavolo del giocatore
		Phaser.Actions.Call(this._playerBoxes.getChildren(), function (box) {
			// assegno eventi alle caselle del giocatore
			if (box.input && box.input.enabled) {
				box.on('pointerup', function () {
					// on click aggiungo un evento nella scena e passo il box e se la ui deve tornare subito ready
					if (box.scene._uiReady) {
						box.scene._uiReady = false;
						this.scene.emitter.emit('playOneLetter', box, true);
					}
				});
				box.on('pointerover', function () {
					if (box.scene._uiReady)
						this.setTint(setup.colors.letterOver);
				});
				box.on('pointerout', function () {
					this.setTint(setup.colors.letter);
				});
			}
		});
		// assegno gli eventi alle caselle del tavolo del giocatore
		Phaser.Actions.Call(superPowerButtons.getChildren(), function (box) {
			box.on('pointerover', function () {
				if (box.scene._uiReady)
					this.setTint(setup.colors.yellow);
			});
			box.on('pointerout', function () {
				this.setTint();
			});
			box.on('pointerdown', function () {
				if (!box.scene._uiReady)
					return;

				// Verifica se ci sono crediti sufficienti PRIMA di procedere
				let superpower = getModel(runtime.superpowers, 'motive', box._type);
				if (!superpower) {
					console.log('Superpotere non trovato per tipo:', box._type);
					return;
				}

				let availableCredits = runtime.ranking.available_credits || 0;
				let cost = superpower.movement;

				if (availableCredits < cost) {
					console.log('Crediti insufficienti per questo superpotere. Disponibili:', availableCredits, 'Richiesti:', cost);
					// Suono errore per crediti insufficienti
					audio.playSound(box.scene, 'error');
					return; // Esci se i crediti sono insufficienti
				}

				// blocco la ui e il tempo.
				box.scene._timerObj.paused = true;
				box.scene._uiReady = false;
				// Salva la posizione originale del cursore prima di iniziare il power
				box.scene._cursor.indexBeforePower = box.scene._cursor.index;
				let arrayLetter = [];
				console.log('superpower usato', superpower);
				// Traccia i crediti spesi in questo round
				if (!runtime._creditsSpentThisRound) runtime._creditsSpentThisRound = 0;
				runtime._creditsSpentThisRound += superpower.movement;
				runtime.ranking.available_credits -= superpower.movement;
				// Lancia animazione sottrazione crediti dal bottone aiuto al contatore power
				box.scene.powerLeapAnimation(box, box.scene._powerCounter, -superpower.movement);
				// Traccia il dettaglio degli aiuti usati per tipo
				if (!runtime._helpsUsedThisRound) runtime._helpsUsedThisRound = {};
				if (!runtime._helpsUsedThisRound[box._type]) runtime._helpsUsedThisRound[box._type] = 0;
				runtime._helpsUsedThisRound[box._type] += 1;
				// Segna che sono stati usati aiuti (solo in memoria, non nel database)
				box.scene._powersUsed = true;
				
				// Suono uso aiuto
				audio.playSound(box.scene, 'power-use');
				switch (box._type) {
					case runtime.constants.superpower.MOTIVE_WORD:
						// Passa la posizione corrente del cursore per rivelare la parola corrente
						arrayLetter = findWords(box.scene._boardBoxes.getChildren(), box.scene._cursor.index);
						//console.log('usato potere WORD. Parola da scoprire', arrayLetter);
						break;
					case runtime.constants.superpower.MOTIVE_CONSONANT:
						// Passa la posizione corrente del cursore per rivelare quella lettera se è una consonante
						arrayLetter = findLetter(box.scene._boardBoxes.getChildren(), runtime.constants.superpower.MOTIVE_CONSONANT, box.scene._cursor.index);
						//console.log('usato potere CONSONANT. Consonanti da scoprire', arrayLetter);
						break;
					case runtime.constants.superpower.MOTIVE_VOWEL:
						// Passa la posizione corrente del cursore per rivelare quella lettera se è una vocale
						arrayLetter = findLetter(box.scene._boardBoxes.getChildren(), runtime.constants.superpower.MOTIVE_VOWEL, box.scene._cursor.index);
						//console.log('usato potere VOWEL. Vocali da scoprire', arrayLetter);
						break;
					case runtime.constants.superpower.MOTIVE_REVEAL_CURRENT:
						// Rivelare solo la casella corrente
						let currentIndex = box.scene._cursor.index;
						let currentBox = box.scene._boardBoxes.getChildren()[currentIndex];
						if (currentBox && currentBox.input && currentBox.input.enabled === true &&
						    currentBox.datas.char === ' ' && currentBox.datas.solution) {
							arrayLetter = [currentIndex];
							console.log('usato potere REVEAL_CURRENT. Casella corrente da scoprire', arrayLetter);
						} else {
							arrayLetter = [];
							console.log('usato potere REVEAL_CURRENT. Casella corrente già risolta o non valida');
						}
						break;
				}
				for (let index of arrayLetter) {
					box.scene._toPlayLetters.unshift(index);
				}
				box.scene.emitter.emit('playPower');
				box.scene.registry.set('power', runtime.ranking.available_credits);
				box.scene._lastUsedPowerButton = box;
				// Aggiorna lo stato dei bottoni superpower dopo aver usato un aiuto
				box.scene.updateSuperPowerButtons();
			});
		});
		/************************************************
		 *
		 * Gestione eventi BOTTONE MENU
		 *
		 *************************************************/
		const showConfirmPopup = () => {
			if (!gameScene._uiReady) return;
			if (gameScene._confirmPopup) return; // Evita popup multipli

			const width = this.sys.game.config.width;
			const height = this.sys.game.config.height;
			const centerX = width / 2;
			const centerY = height / 2;

			// Crea overlay scuro
			gameScene._confirmOverlay = this.add.rectangle(centerX, centerY, width, height, 0x000000, 0.7);
			gameScene._confirmOverlay.setDepth(1000);

			// Crea popup background usando createTableBackground se disponibile, altrimenti un rettangolo semplice
			const popupWidth = 500;
			const popupHeight = 300;
			const popupBg = this.add.graphics();
			popupBg.fillStyle(0xFFFFFF, 1);
			popupBg.fillRoundedRect(centerX - popupWidth / 2, centerY - popupHeight / 2, popupWidth, popupHeight, 20);
			popupBg.setDepth(1001);

			// Crea header blu
			const headerHeight = 60;
			const headerBg = this.add.graphics();
			headerBg.fillStyle(0x2C6B9B, 1);
			headerBg.fillRoundedRect(centerX - popupWidth / 2, centerY - popupHeight / 2, popupWidth, headerHeight, 20);
			headerBg.setDepth(1002);

			// Testo del popup
			const confirmText = this.add.text(
				centerX,
				centerY - 40,
				'Vuoi concludere la partita?',
				{
					fontSize: 28,
					fontFamily: 'Luckiest Guy',
					fill: '#1567a3',
					align: 'center'
				}
			).setOrigin(0.5).setDepth(1003);

			// Bottone SI (verde)
			const buttonYes = new Button(
				this,
				centerX - 100,
				centerY + 60,
				'green-button',
				0.4,
				'SI'
			);
			buttonYes.setDepth(1003);

			// Bottone NO (rosso)
			const buttonNo = new Button(
				this,
				centerX + 100,
				centerY + 60,
				'red-button',
				0.4,
				'NO'
			);
			buttonNo.setDepth(1003);

			// Salva riferimento al popup
			gameScene._confirmPopup = {
				overlay: gameScene._confirmOverlay,
				bg: popupBg,
				header: headerBg,
				text: confirmText,
				buttonYes: buttonYes,
				buttonNo: buttonNo
			};

			// Evento bottone NO - chiudi popup
			buttonNo.once('pointerup', () => {
				gameScene.closeConfirmPopup();
			});

			// Evento bottone SI - concludi partita (come se fosse finito il tempo)
			buttonYes.once('pointerup', () => {
				gameScene.closeConfirmPopup();
				// Calcola il tempo rimasto reale prima di fermare il timer
				let timeRemaining = 0;
				if (gameScene._timerObj && gameScene._initialTimeSeconds) {
					timeRemaining = Math.floor((gameScene._initialTimeSeconds * 1000 - gameScene._timerObj.getElapsed()) / 1000);
					timeRemaining = Math.max(0, timeRemaining);
				}
				runtime.round.time_used = timeRemaining;
				// Ferma il timer
				if (gameScene._timerObj) {
					gameScene._timerObj.paused = true;
					gameScene._timerObj.remove();
				}
				// Imposta il tempo rimasto nel registry per la scena game-over
				gameScene.registry.set('time', timeRemaining);
				gameScene.registry.set('score', runtime.round.score);
				// Emetti l'evento gameOver come se fosse finito il tempo (status LOST)
				gameScene.emitter.emit('gameOver', Constants.ROUND_STATUS_LOST);
			});
		};

		const openMenu = () => {
			if (!gameScene._uiReady) return;
			// Mostra popup di conferma invece di aprire direttamente il menu
			showConfirmPopup();
		};

		this._menuButton.on('pointerup', openMenu);
		this._menuButton.on('pointerover', function () {
			if (!gameScene._uiReady) return;
			this.setAlpha(1);
		});
		this._menuButton.on('pointerout', function () {
			this.setAlpha(setup.various.helpButton.alpha);
		});

		/************************************************
		 *
		 * Gestione eventi BOTTONE HELP
		 *
		 *************************************************/
		this._helpButton.on('pointerup', function () {
			if (!gameScene._uiReady) return;
			this.setAlpha(setup.various.helpButton.alpha);
			// Lancia la scena HowtoPlay
			gameScene.scene.launch('HowtoPlay');
			// Ottieni la scena e cambia il testo del bottone
			// (changeTextButton ora gestisce il caso in cui il bottone non sia ancora pronto)
			let howtoPlay = gameScene.scene.get('HowtoPlay');
			howtoPlay.changeTextButton('Indietro');
			// necessario perchè in index.js HowPlay è caricato prima di Game,
			// dunque HowtoPlay ha depth 1 e Game ha depth 2
			gameScene.scene.bringToTop('HowtoPlay');
			gameScene.scene.pause();
		});
		this._helpButton.on('pointerover', function () {
			if (!gameScene._uiReady) return;
			// controllo se un bottone normale o casella di gioco
			this.setAlpha(1);
		});
		this._helpButton.on('pointerout', function () {
			// controllo se un bottone normale o casella di gioco
			this.setAlpha(setup.various.helpButton.alpha);
		});
		// registro i  punti power iniziali dell'utente
		// nessuna animazione all'inizio
		this.registry.set('power', runtime.ranking.available_credits);
		// Inizializza il punteggio nel registry all'inizio del round
		this.registry.set('score', runtime.round.score || 0);

		// Inizializza il tempo rimasto all'inizio del round
		// Prova prima a recuperare dal localStorage (per gestire i reload)
		let savedTime = localStorage.getItem('tanaca_round_' + runtime.round.id + '_time');
		if (savedTime !== null) {
			runtime.round.time_used = parseInt(savedTime);
			console.log('Tempo ripreso dal localStorage:', runtime.round.time_used);
			// Rimuovi dal localStorage per evitare che venga usato in round futuri
			// (verrà risalvato dall'interval)
		} else if (runtime.round.time_used === null || runtime.round.time_used === undefined) {
			runtime.round.time_used = runtime.mode.available_time;
			console.log('Tempo inizializzato a available_time:', runtime.mode.available_time);
		} else {
			console.log('Tempo ripreso dal round esistente:', runtime.round.time_used);
		}
		this._clockCounter.update(runtime.round.time_used);

		// Salva il tempo iniziale per i calcoli successivi
		this._initialTimeSeconds = runtime.round.time_used;

		// Avvia il timer con il tempo rimasto (non sempre available_time)
		let timeRemainingMs = runtime.round.time_used * 1000;
		console.log('Timer avviato con tempo rimasto:', runtime.round.time_used, 'secondi');
		this._timerObj = this.time.addEvent({
			delay: timeRemainingMs,
			callback: function () {
				//console.log("emesso evento gameOver", runtime.mode.available_time, this._timerObj);
				this.emitter.emit('gameOver', Constants.ROUND_STATUS_LOST);
			},
			callbackScope: this
		});

		// Salva il tempo nel localStorage periodicamente per recuperarlo dopo un reload
		this._saveTimeInterval = setInterval(() => {
			if (!this._gameOver && this._timerObj) {
				let currentTime = Math.floor((this._initialTimeSeconds * 1000 - this._timerObj.getElapsed()) / 1000);
				currentTime = Math.max(0, currentTime);
				localStorage.setItem('tanaca_round_' + runtime.round.id + '_time', currentTime.toString());
			}
		}, 5000); // Salva ogni 5 secondi

		// Salva il tempo prima di chiudere/ricaricare la pagina
		this._beforeUnloadHandler = () => {
			if (!this._gameOver && this._timerObj) {
				let currentTime = Math.floor((this._initialTimeSeconds * 1000 - this._timerObj.getElapsed()) / 1000);
				currentTime = Math.max(0, currentTime);
				localStorage.setItem('tanaca_round_' + runtime.round.id + '_time', currentTime.toString());
			}
		};
		window.addEventListener('beforeunload', this._beforeUnloadHandler);

		// Oggetto tween per le lettere
		/*let twDestPos = {x: 100, y: 100};
		 let newLetter = new Letter(this, 0, 0, 'C').setOrigin(0.5);
		 this._tw = this.tweens.add({
		 targets: newLetter,
		 x: 10,
		 y: 10,
		 ease: 'Elastic',
		 paused: false,
		 easeParams: [0.5, 0.25],
		 duration: 400,
		 delay: 0,
		 yoyo: false,
		 onCompleteScope: this,
		 repeat: 0,
		 });*/

		// Ascolto l'evento playOneLetter per ogni lettera giocata. Il terzo parametro binda il contesto
		// la callback è chiamata con il parametro box
		this.emitter.on('playOneLetter', this.playOneLetter, this);
		// Ascolto l'evento gameOver. La callback è chiamata con l'argomento win true|false
		this.emitter.once('gameOver',
			function (roundStatus) {
				console.log('gameOver Event called');
				// Segna che il gioco è finito
				runtime.gameInProgress = false;

				// Pulisci interval e event listener per il salvataggio del tempo
				if (this._saveTimeInterval) {
					clearInterval(this._saveTimeInterval);
				}
				if (this._beforeUnloadHandler) {
					window.removeEventListener('beforeunload', this._beforeUnloadHandler);
				}
				// Rimuovi il tempo salvato nel localStorage per questo round
				localStorage.removeItem('tanaca_round_' + runtime.round.id + '_time');

				// Calcola il tempo rimasto PRIMA di fermare il timer
				// Usa _initialTimeSeconds invece di available_time
				let timeRemaining = Math.floor((this._initialTimeSeconds * 1000 - this._timerObj.getElapsed()) / 1000);
				// Assicurati che non sia negativo
				timeRemaining = Math.max(0, timeRemaining);

				// Salva il tempo rimasto nel registry per la schermata game-over
				this.registry.set('time', timeRemaining);
				this.registry.set('score', runtime.round.score);

				// Fermo il tempo nel caso in cui non lo sia già (partita vinta)
				this._timerObj.paused = true;
				this._timerObj.remove();

				// Ferma l'aggiornamento continuo di time_used nell'update()
				this._gameOver = true;
				// rimuovo il gruppo delle lettere
				/*this._boardBoxes.clear(true);
				 this._boardBoxes.destroy();
				 this._playerBoxes.clear(true);
				 this._playerBoxes.destroy();*/
				// Cancello le lettere dallo schema
				/*for (let i = 0; i < 80; i++) {
				 if (this._boardLetters[i])
				 this._boardLetters[i].destroy();
				 }*/
				// Cancello le lettere del giocatore
				/*for (let i = 0; i < 20; i++) {
				 if (this._playerLetters[i])
				 this._playerLetters[i].destroy();
				 }*/
				// disabilito la UI
				this._uiReady = false;
				// metto in pausa la scena in modo che rimanga sullo sfondo
				let gameScene = this.scene.get('Game');
				//gameScene.events.off();
				gameScene.scene.pause('Game');
				// spengo gli eventi
				//gameScene.events.off();
				//gameScene.events.off('playPower');
				// lancio la scena del gameover in parallelo

				this.scene.run('GameOver', {round: Constants.ROUND_END, status: roundStatus})
				//this.events.off('playPower');
				//this.scene.stop();
			},
			this);

		this.emitter.on(
			'playPower',
			function (target) {
				console.log('PlayPower event', this._toPlayLetters);
				if (this._toPlayLetters.length === 0) {
					// finita la coda riattivo tempo e interfaccia
					this._uiReady = true;
					this._timerObj.paused = false;

					// Verifica se la lettera nella posizione originale è stata risolta dall'aiuto
					let originalBox = this._boardBoxes.getChildren()[this._cursor.indexBeforePower];
					let letterWasSolved = originalBox.datas.char !== ' ' && originalBox.datas.char !== false;

					if (letterWasSolved) {
						// La lettera nella posizione originale è stata risolta, sposta il cursore alla prossima lettera vuota
						let nextCursor = this._cursor.findNextCursor(this._schemaArray.length - 1, this._cursor.indexBeforePower);
						if (nextCursor === false) {
							// se non ci sono più cursori hai finito lo schema con vittoria
							this.emitter.emit('gameOver', Constants.ROUND_STATUS_WON);
						} else {
							// Sposta il cursore alla prossima lettera vuota partendo dalla posizione originale
							this._cursor.move(nextCursor.datas.id);
							console.log('Cursore spostato dopo power: la lettera originale è stata risolta, da', this._cursor.indexBeforePower, 'a', nextCursor.datas.id);
						}
					} else {
						// La lettera nella posizione originale NON è stata risolta, il cursore rimane fermo
						// Ripristina l'animazione del cursore nella posizione originale
						this._cursor.move(this._cursor.indexBeforePower);
						console.log('Cursore rimasto fermo: la lettera originale non è stata risolta, posizione', this._cursor.indexBeforePower);
					}

					console.log('lastUsedPowerButton', this._lastUsedPowerButton);
					if (hasUnsolvedLetter(this._boardBoxes.getChildren(), this._lastUsedPowerButton._type).length === 0) {
						//vocali finite
						console.log('vocali finite');
						this._lastUsedPowerButton.input.enabled = false;
					}

					return;
				}
				// prendo il primo in coda
				let index = this._toPlayLetters.pop();
				//console.log('pop index', index);
				let destBox = this._boardBoxes.getChildren()[index];
				//console.log('destBox boardBoxes', destBox);
				let sourceBox = findBoxLetter(this._playerBoxes, destBox.datas.solution);
				//console.log('sourceBox boardBoxes', sourceBox);

				// NON spostare il cursore visibile durante l'inserimento delle lettere del power
				// Il cursore verrà spostato alla fine quando finisce la coda
				// Passa l'index come terzo parametro per indicare la posizione target
				this.emitter.emit('playOneLetter', sourceBox, false, index);
			},
			this);
		/************************************************
		 *
		 * Gestione eventi POWERCHECK EVENT
		 *
		 *************************************************/
		this.registry.events.on(
			'changedata',
			function (parent, key) {
				//console.log('registry update');
				if (key === 'power') {
					//console.log('power changed', runtime.ranking.available_credits);
					// Aggiorna lo stato dei bottoni superpower quando cambiano i crediti
					this.updateSuperPowerButtons();
				}
			},
			this);
		// riattivo la UI nel caso si tratti di un riavvio della scena
		this._uiReady = true;

		// Handler per quando la scena viene ripresa dopo una pausa
		this.events.on('resume', () => {
			console.log('Game scene resumed');
			// Ri-sincronizza i contatori con i valori correnti
			if (this._scoreCounter) {
				this._scoreCounter.update(runtime.round.score);
			}
			if (this._powerCounter) {
				this._powerCounter.update(runtime.ranking.available_credits);
			}
			// Aggiorna lo stato dei bottoni superpower
			this.updateSuperPowerButtons();
			if (this._clockCounter && this._timerObj) {
				let timeRemaining = Math.floor((runtime.mode.available_time * 1000 - this._timerObj.getElapsed()) / 1000);
				this._clockCounter.update(Math.max(0, timeRemaining));
			}
			// Riattiva la UI
			this._uiReady = true;
		});

		// Handler per quando la scena viene fermata - rimuove i listener dall'EventDispatcher
		this.events.on('shutdown', this.shutdown, this);
	}

	/**
	 *  Gioca una lettera
	 *
	 *  @param {Phaser.GameObject.Sprite} box - Il box premuto dal giocatore
	 *  @param {boolean} isPowerActivated - Se la funzione è lanciata utilizzando un super power
	 *
	 */
	playOneLetter(box, isPlayerActivated, targetIndex = null) {
		// clic su una casella del giocatore
		console.log('[Game] playOneLetter: lettera=', box.datas.char, 'isPlayerActivated=', isPlayerActivated, 'targetIndex=', targetIndex);
		console.log('[Game] playOneLetter: cursore attuale=', this._cursor.index);
		// seleziono la casella di destinazione del tavolo da gioco
		// Se targetIndex è specificato (power), usa quello, altrimenti usa la posizione corrente del cursore
		let destBoxIndex = targetIndex !== null ? targetIndex : this._cursor.index;
		console.log('[Game] playOneLetter: destBoxIndex=', destBoxIndex);
		let destBox = this._boardBoxes.getChildren()[destBoxIndex];
		//console.log('box corrente board', destBox.datas, destBox.x, destBox.y);
		// nuova lettera per lo schema, assegno uno spazio per ora, da usare come target animazione
		var newLetter = new Letter(this, box.x, box.y, box.datas.char).setOrigin(0.5);
		// aggiorno l'array globale delle lettere del tavolo
		this._boardLetters[destBoxIndex] = newLetter;
		// preparo animazione
		let x = destBox.x;
		let y = destBox.y;
		// Controllo se la lettera è giusta
		if (this._solutionArray[destBoxIndex] === box.datas.char) {
			// lettera esatta
			//console.log('lettera esatta', box.datas.char);
			// casella vinta non piu cliccabile
			destBox.input.enabled = false;
			/*
			 this._tw.data[0].target = newLetter;
			 this._tw.data[1].target = newLetter;
			 this._tw.data[0].getStartValue = function (target, key, value, targetIndex, totalTargets, tween) {
			 return target.x;
			 };
			 this._tw.data[0].getEndValue = function (target, key, value, targetIndex, totalTargets, tween) {
			 return x;
			 };
			 this._tw.data[1].getStartValue = function (target, key, value, targetIndex, totalTargets, tween) {
			 return target.y;
			 };
			 this._tw.data[1].getEndValue = function (target, key, value, targetIndex, totalTargets, tween) {
			 return y;
			 };
			 console.log(this._tw);
			 this._tw.onCompleteParams = this;
			 this._tw.setCallback('onComplete', function (tween, targets, gameScene, box) {
			 console.log("onComplete this", this);
			 console.log("onComplete gameScene", gameScene);
			 console.log("onComplete tween", tween);
			 console.log("onComplete targets", targets);
			 console.log("onComplete box", box);
			 // assegno la lettera ai custom data del box
			 destBox.datas.char = box.datas.char;
			 // rendo visibile la lettera. Da spazio adesso viene assegnata la lettera reale
			 newLetter.text = box.datas.char;
			 // aggiorno il contatore lettere rimaste
			 gameScene._toWinLetters--;
			 // aggiorno lo score
			 runtime.round.score += setup.game.score.won;

			 gameScene.leapAnimation(gameScene._scoreCounter, '+' + setup.game.score.won);
			 // posiziono il nuovo cursore
			 let newCursor = gameScene._cursor.findNextCursor(gameScene._schemaArray.length - 1, gameScene._cursor.index);
			 console.log('new cursor', newCursor);
			 if (newCursor === false) {
			 // se non ci sono più cursori hai finito lo schema con vittoria
			 gameScene.events.emit('gameOver', Constants.ROUND_STATUS_WON);
			 } else if (!isPlayerActivated) {
			 console.log('is Power Activated. Emit next event');
			 // questo spostamento va fatto solo al termine dell'array di power
			 box.scene._cursor.indexAfterPower = newCursor.datas.id;
			 gameScene.events.emit('playPower');
			 } else {
			 // muovo il cursore e riattivo ui
			 console.log('is user Activated');
			 gameScene._uiReady = true;
			 gameScene._cursor.move(newCursor.datas.id);
			 }
			 }, [this._tw, this, this, box], this);
			 this._tw.restart();*/
			// preparo animazione
			/*if (this._tw1) {
			 this._tw1.stop();
			 //this._tw1.destroy();
			 }*/
			//	this._animation[newIndex].resetTweenData(true);
			//this.tw_animation[newIndex].resume(true);
			this._tw1 = this.tweens.add(
				{
					targets: newLetter,
					x: x,
					y: y,
					//ease: 'Power1',
					ease: 'Elastic',
					easeParams: [0.5, 0.25],
					duration: 400,
					delay: 0,
					yoyo: false,
					repeat: 0,
					// assegno tutti i bonus al completamento dell'animazione
					onComplete: function (tween, targets, gameScene) {
						console.log("twwen complete", tween);

						// assegno la lettera ai custom data del box
						destBox.datas.char = box.datas.char;
						// rendo visibile la lettera. Da spazio adesso viene assegnata la lettera reale
						newLetter.text = box.datas.char;
						// aggiorno il contatore lettere rimaste
						this._toWinLetters--;

						if (!isPlayerActivated) {
							// Lettera rivelata con aiuto: NON aggiungere punti e NON animare il contatore
							// Durante un power, NON calcoliamo il nuovo cursore ad ogni lettera
							// Verrà calcolato alla fine del power partendo dalla posizione originale (indexBeforePower)
							gameScene.emitter.emit('playPower');
						} else {
							// Lettera indovinata dal giocatore: aggiungi punti e anima il contatore
							// Suono posizionamento lettera
							audio.playSound(gameScene, 'letter-place');
							
							// aggiorno lo score basato sul valore della lettera
							let letterScore = gameScene.getLetterScore(box.datas.char);
							runtime.round.score += letterScore;
							gameScene.leapAnimation(gameScene._scoreCounter, '+' + letterScore);
							// muovo il cursore e riattivo ui
							// Calcola il prossimo cursore partendo dalla posizione corrente
							let newCursor = gameScene._cursor.findNextCursor(gameScene._schemaArray.length - 1, gameScene._cursor.index);
							if (newCursor === false) {
								// se non ci sono più cursori hai finito lo schema con vittoria
								gameScene.emitter.emit('gameOver', Constants.ROUND_STATUS_WON);
							} else {
								gameScene._uiReady = true;
								gameScene._cursor.move(newCursor.datas.id);
							}
						}
					},
					onCompleteParams: [this]
				},
				this);

		} else {
			//console.log('lettera sbagliata', box.datas.char);
			// Suono errore
			audio.playSound(this, 'error');
			
			// preparo animazione
			this._tw1 = this.tweens.add(
				{
					targets: newLetter,
					x: x,
					y: y,
					ease: 'Elastic',
					duration: 400,
					delay: 0,
					yoyo: true,
					repeat: 0,
					onComplete: function (tween, target, gameScene) {
						//console.log('on Complete animation', this, gameScene);
						if (isPlayerActivated) {
							//console.log('is Player Activate');
							gameScene._uiReady = true;
						}
						gameScene._timerObj.delay -= runtime.mode.tick_lost * 1000;
						runtime.round.time_used -= runtime.mode.tick_lost * 1000;
						gameScene.leapAnimation(gameScene._clockCounter, -runtime.mode.tick_lost);
					},
					onCompleteParams: [this]
				},
				this);
		}
	}

	leapAnimation(counter, value) {
		counter.textLeapAnimation(value);
	}

	/**
	 * Animazione che parte dal bottone aiuto e arriva al contatore power
	 * Simile a leapAnimation ma con punto di partenza personalizzato
	 *
	 * @param {Phaser.GameObjects.GameObject} sourceButton - Il bottone aiuto da cui parte l'animazione
	 * @param {Counter} counter - Il contatore di destinazione (powerCounter)
	 * @param {number} value - Il valore da mostrare (negativo per sottrazione crediti)
	 */
	powerLeapAnimation(sourceButton, counter, value) {
		// Crea il testo temporaneo alla posizione del bottone aiuto
		let animText = this.add.text(sourceButton.x, sourceButton.y, value, setup.styles.leapStyle)
			.setOrigin(0.5)
			.setColor(setup.colors.leapStyleFillColor.lost)
			.setDepth(100);

		// Calcola la destinazione (centro del counter power)
		let destX = counter.getBounds().x + counter.getBounds().width / 2;
		let destY = counter.getBounds().y + counter.getBounds().height / 4;

		// Animazione tween dal bottone aiuto al contatore
		this.tweens.add({
			targets: animText,
			x: destX,
			y: destY,
			alpha: 0.3,
			ease: 'Power2',
			duration: 800,
			delay: 0,
			yoyo: false,
			repeat: 0,
			onComplete: function(tween, targets) {
				animText.destroy();
			}
		});
	}

	/**
	 * Calcola il punteggio per una lettera basandosi sulle mappe di punteggio
	 * @param {string} letter - La lettera per cui calcolare il punteggio
	 * @returns {number} Il punteggio della lettera o 1 come fallback
	 */
	getLetterScore(letter) {
		let upperLetter = letter.toUpperCase();
		return setup.game.score.vowels.get(upperLetter) ||
		       setup.game.score.consonants.get(upperLetter) ||
		       setup.game.score.won; // fallback a 1 se lettera non trovata
	}

	/**
	 * Aggiorna lo stato dei bottoni superpower in base ai crediti disponibili
	 * Disabilita i bottoni che richiedono più crediti di quelli disponibili
	 */
	updateSuperPowerButtons() {
		if (!this._superPowerButtons) return;

		let availableCredits = runtime.ranking.available_credits || 0;

		// Itera su tutti i bottoni superpower
		this._superPowerButtons.getChildren().forEach((button) => {
			// Ottieni il costo del superpotere
			let superpower = getModel(runtime.superpowers, 'motive', button._type);
			if (superpower) {
				let cost = superpower.movement;
				// Disabilita il bottone se i crediti disponibili sono insufficienti
				if (availableCredits < cost) {
					button.setInteractive(false);
					button.setAlpha(0.5); // Rendi il bottone semi-trasparente quando disabilitato
				} else {
					button.setInteractive(true);
					button.setAlpha(1); // Rendi il bottone completamente visibile quando abilitato
				}
			}
		});
	}

	/**
	 * Chiude il popup di conferma
	 */
	closeConfirmPopup() {
		if (this._confirmPopup) {
			if (this._confirmPopup.overlay) this._confirmPopup.overlay.destroy();
			if (this._confirmPopup.bg) this._confirmPopup.bg.destroy();
			if (this._confirmPopup.header) this._confirmPopup.header.destroy();
			if (this._confirmPopup.text) this._confirmPopup.text.destroy();
			if (this._confirmPopup.buttonYes) this._confirmPopup.buttonYes.destroy();
			if (this._confirmPopup.buttonNo) this._confirmPopup.buttonNo.destroy();
			this._confirmPopup = null;
		}
		if (this._confirmOverlay) {
			this._confirmOverlay.destroy();
			this._confirmOverlay = null;
		}
	}

	/**
	 *  Called when a scene is updated. Updates to game logic, physics and game
	 *  objects are handled here.
	 *
	 *  @protected
	 *  @param {number} t Current internal clock time.
	 *  @param {number} dt Time elapsed since last update.
	 */
	update(/* t, dt */) {
		if (!this.scene.isPaused() && this.scene.isActive() && !this._gameOver) {
			/* il tempo deve essere espresso in secondi */
			// NON aggiornare time_used se il gioco è finito
			// Usa _initialTimeSeconds invece di available_time per gestire i round ripresi
			runtime.round.time_used = Math.floor((this._initialTimeSeconds * 1000 - this._timerObj.getElapsed()) / 1000);
			runtime.round.time_used = Math.max(0, runtime.round.time_used);
			this._clockCounter.update(runtime.round.time_used);
			this._scoreCounter.update(runtime.round.score);
			this._powerCounter.update(runtime.ranking.available_credits);
		}
	}

	/**
	 *  Chiamato quando la scena viene fermata o distrutta.
	 *  Rimuove i listener dall'EventDispatcher singleton per evitare
	 *  listener duplicati quando si cambia gioco.
	 *
	 *  @protected
	 */
	shutdown() {
		console.log('[Game] shutdown: rimozione listener dall\'EventDispatcher');
		// Rimuovi i listener dall'emitter singleton
		if (this.emitter) {
			this.emitter.off('playOneLetter', this.playOneLetter, this);
			this.emitter.off('playPower');
		}
		// Pulisci interval e event listener
		if (this._saveTimeInterval) {
			clearInterval(this._saveTimeInterval);
		}
		if (this._beforeUnloadHandler) {
			window.removeEventListener('beforeunload', this._beforeUnloadHandler);
		}
	}
}
